/* eslint-disable camelcase */
import { trackPage } from ".";
import PagesEnum from "./enums/pages";
import LevelsEnum from "./enums/levels";

// Pages tracking

export function trackPageNoResultPage(content_ct: string) {
  return trackPage({
    page: PagesEnum.NoResult,
    page_chapter1: content_ct,
    page_chapter2: PagesEnum.NoResult,
    site_level2: LevelsEnum.Dynamic,
  });
}
